import { ResponsePage } from '../../../types/reduxSaga-deprecated'

export enum CompanyType {
  ENK = 'ENK',
  PMV = 'PMV',
}

export type Company = {
  city: string
  companyType: CompanyType
  email: string | null
  fax: string | null
  firstFiscalYearEnd: string | null
  firstFiscalYearStart: string | null
  fiscalYearEnd: string | null
  fiscalYearStart: string | null
  id: string
  name: string | null
  legalName?: string | null
  number?: string
  numberTo: string | null
  phone: string | null
  state: string
  street: string
  text: string
  type: string | null
  vatNo: string | null
  www: string | null
  zipcode: string
}

export type FrenchCompany = {
  id: string
  siret: string
  siren: string
  name: string | null
  city: string
  street: string | null
  zipcode: string | null
  country: string
  establishmentTradeName: string | null
  establishmentCommercialSign: string | null
  legalName: string | null
  legalFormCode: string | null
  legalForm: string | null
  legalRepresentativeFirstName: string | null
  legalRepresentativeLastName: string | null
}

export type CompaniesState = {
  companies: {
    list?: Company[] | null
    page?: ResponsePage | null
  }
}
